import React from "react";
import DefaultTable from "../../components/Common/DefaultTable";
import { TableRow } from "@material-ui/core";
import { formatDatesOnList } from "helpers/utils";

function AttacksTable(props) {
  const {
    attacks,
    headCells,
    handleEntityClick,
    isLoading,
    defaultTable,
    optionalCellRender,
  } = props;

  const {
    renderHeadCell,
    renderCheckRowCell,
    renderCheckAllCell,
    isSelected,
    handleClick,
    renderBodyCell,
  } = defaultTable;

  const formattedAttacks = formatDatesOnList(
    attacks,
    "LLL",
    "createdAt",
    "updatedAt"
  );

  const renderDefaultBody = () => {
    return formattedAttacks.map((attack) => {
      const { id } = attack;
      const isItemSelected = isSelected(id);
      let categoryIds = [],
        categoryTypeIds = [];
      for (let x of attack.category || []) {
        categoryIds.push(x.name);
        categoryTypeIds.push(...[...x.types]);
      }
      return (
        <TableRow
          hover
          role="checkbox"
          onClick={() => {
            handleEntityClick(attack);
          }}
          aria-checked={isItemSelected}
          tabIndex={-1}
          key={id}
          selected={isItemSelected}
        >
          {renderCheckRowCell(isItemSelected, id, (e) => {
            handleClick(e, id);
          })}
          {optionalCellRender("id", renderBodyCell(id))}
          {optionalCellRender("name", renderBodyCell(attack.name))}
          {optionalCellRender(
            "category",
            renderBodyCell(categoryIds.join(", "))
          )}
          {optionalCellRender(
            "type",
            renderBodyCell(categoryTypeIds.join(", "))
          )}
          {optionalCellRender(
            "attackPhase",
            renderBodyCell(attack.attackPhase)
          )}
          {optionalCellRender("target", renderBodyCell(attack.target))}
          {optionalCellRender("status", renderBodyCell(attack.status))}
          {optionalCellRender("level", renderBodyCell(attack.level))}
          {optionalCellRender("createdAt", renderBodyCell(attack.createdAt))}
          {optionalCellRender("updatedAt", renderBodyCell(attack.updatedAt))}
          {optionalCellRender(
            "createdByUsername",
            renderBodyCell(attack.createdByUsername)
          )}
          {optionalCellRender(
            "updatedByUsername",
            renderBodyCell(attack.updatedByUsername)
          )}
        </TableRow>
      );
    });
  };

  return (
    <DefaultTable
      headCells={headCells}
      isLoading={isLoading}
      renderCheckAllCell={renderCheckAllCell}
      renderDefaultBody={renderDefaultBody}
      renderHeadCell={renderHeadCell}
      rows={formattedAttacks}
      selectableRows
    />
  );
}

export default AttacksTable;
